<!--
  - Copyright (c) 2021 brightlamp
  -->

<template>
    <div>
        <v-dialog v-model="dialogLocal" persistent scrollable max-width="540px">
            <v-card>
                <v-card-title>
                    <span class="headline" align="center" style="color:#FFFD00;background-color:#363636;width:100%;display:block;">Send Message</span>
                </v-card-title>
                <v-card-text id="messageCreationId">
                    <v-progress-linear v-if="waiting" :indeterminate="true"/>
                    <v-checkbox v-model="jobNamesCheckBox"
                                label="Select/Deselect All Jobs"
                                :indeterminate="jobNamesCheckBoxIndeterminateState"
                                @change="checkAllJobsAction"
                                color="black"
                                hide-details>
                    </v-checkbox>
                    <v-select v-model="jobsSelected"
                              :items="jobNames"
                              label="Select Jobs"
                              multiple
                              chips>
                    </v-select>
                    <v-checkbox v-model="useNamesCheckBox"
                                label="Select/Deselect All Uses"
                                :indeterminate="useNamesCheckBoxIndeterminateState"
                                @change="checkAllUsesAction"
                                color="black"
                                hide-details>
                    </v-checkbox>
                    <v-select v-model="usesSelected"
                              :items="useNames"
                              label="Select Uses"
                              multiple
                              chips>
                    </v-select>
                    <v-btn class="my-4" @click="selectUser" color="accent">
                        <span style="color: #000000;">Select User</span>
                    </v-btn>
                    <v-row align="center" justify="start" class="mb-4">
                        <v-col v-for="(userSelected, index) in usersSelected" :key="usersSelected.id" class="shrink">
                            <v-chip close @click:close="usersSelected.splice(index, 1)">
                                {{ userSelected.displayName }}
                            </v-chip>
                        </v-col>
                    </v-row>
                    <v-select v-model="categorySelected"
                              :items="categoryList"
                              label="Select Category">
                    </v-select>
                    <v-text-field
                        v-model="subject"
                        label="Message Subject">
                    </v-text-field>
                    <v-container pt-3 pb-0 px-0>
                        <v-textarea
                            v-model="body"
                            outlined
                            label="Message Body">
                        </v-textarea>
                    </v-container>
                </v-card-text>
                <v-card-actions class="mr-2">
                    <v-spacer/>
                    <v-btn color="blue darken-1" text @click="closeDialog">Cancel</v-btn>
                    <v-btn color="blue darken-1" text @click="send">Send</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <UserSearchDialog :dialog="userSearchDialog" @dialog-close="userSearchDialogClose"/>
    </div>
</template>

<script>

    import {mapActions, mapMutations, mapState} from 'vuex';
    import {jobs, uses} from '@/components/user-mappings.mjs'
    import UserSearchDialog from '@/components/user-search-dialog';

    export default
    {
        name: 'create-message-dialog',
        components:
        {
            UserSearchDialog
        },
        data: function ()
        {
            return {
                dialogLocal: false,
                subject: '',
                body: '',
                jobsSelected: [],
                jobNamesCheckBox: false,
                jobNamesCheckBoxIndeterminateState: false,
                usesSelected: [],
                useNamesCheckBox: false,
                useNamesCheckBoxIndeterminateState: false,
                userSearchDialog: false,
                usersSelected: [],
                categorySelected: '',
                refreshList: false
            }
        },
        props:
        {
            dialog: Boolean(false),
            messageToEdit: {}
        },
        computed:
        {
            ...mapState('messages',
            {
                categories: state => state.categories
            }),
            ...mapState('users',
            {
                users: state => state.users
            }),
            ...mapState('common',
            {
                waiting: state => state.waiting
            }),
            jobNames()
            {
                return this.listGeneration(jobs)
            },
            useNames()
            {
                return this.listGeneration(uses)
            },
            categoryList()
            {
                return this.listGeneration(this.categories)
            }
        },
        watch:
        {
            async dialogLocal(val)
            {
                // If the dialog is being closed
                if (!val)
                {
                    this.HIDE_SNACKBAR();
                    this.$emit('dialog-close', this.refreshList)
                }
                else // Else the dialog is being opened
                {
                    // If we have a message to edit
                    if (this.messageToEdit)
                    {
                        this.subject = this.messageToEdit.subject;
                        this.body = this.messageToEdit.body;
                        this.categorySelected = this.messageToEdit.categoryText;

                        // If there are destinations
                        if (this.messageToEdit.destinations)
                        {
                            // If there are job codes
                            if (this.messageToEdit.destinations['1'])
                            {
                                this.jobsSelected = this.valuesFromList(this.messageToEdit.destinations['1'], jobs)
                            }
                            // If there are use codes
                            if (this.messageToEdit.destinations['2'])
                            {
                                this.usesSelected = this.valuesFromList(this.messageToEdit.destinations['2'], uses)
                            }
                            // If there are user IDs
                            if (this.messageToEdit.destinations['3'])
                            {
                                await this.getUserInfo(this.messageToEdit.destinations['3'])
                            }
                        }
                    }
                }
            },
            dialog(val)
            {
                this.subject = '';
                this.body = '';
                this.categorySelected = '';
                this.dialogLocal = val
            },
            jobsSelected()
            {
                // -1 account for not use N/A
                this.jobNamesCheckBoxIndeterminateState = this.jobsSelected.length > 0 && this.jobsSelected.length < this.jobNames.length - 1;
                this.jobNamesCheckBox = this.jobsSelected.length === this.jobNames.length - 1
            },
            usesSelected()
            {
                // -1 account for not use N/A
                this.useNamesCheckBoxIndeterminateState = this.usesSelected.length > 0 && this.usesSelected.length < this.useNames.length - 1;
                this.useNamesCheckBox = this.usesSelected.length === this.useNames.length - 1
            }
        },
        methods:
        {
            ...mapActions('messages', ['UPSERT_MESSAGE']),
            ...mapActions('users', ['GET_USERS']),
            ...mapMutations('common', ['WAITING', 'SHOW_SNACKBAR_ERROR', 'HIDE_SNACKBAR']),
            closeDialog()
            {
                document.getElementById('messageCreationId').scrollTop = 0;
                this.dialogLocal = false
            },
            checkAllJobsAction()
            {
                this.jobsSelected = this.jobNamesCheckBox ? this.jobNames : []
            },
            checkAllUsesAction()
            {
                this.usesSelected = this.useNamesCheckBox ? this.useNames : []
            },
            async send()
            {
                try
                {
                    this.HIDE_SNACKBAR();

                    this.subject = this.subject.trimEnd();
                    this.body = this.body.trimEnd();

                    if ('' === this.subject || '' === this.body || !this.categorySelected)
                    {
                        this.SHOW_SNACKBAR_ERROR('A subject, body, and category are needed before a message can be sent.');
                        return
                    }

                    this.WAITING(true);

                    const message =
                    {
                        subject: this.subject,
                        body: this.body,
                        category: this.keyFromList(this.categorySelected, this.categories),
                        destinations: this.buildDestination()
                    }
                    // If an existing message was being edited, make sure to include the ID in the request to the server
                    if (this.messageToEdit)
                    {
                        message.id = this.messageToEdit.id
                    }
                    await this.UPSERT_MESSAGE(message);
                    this.refreshList = true;
                    this.dialogLocal = false
                }
                catch (error)
                {
                    this.SHOW_SNACKBAR_ERROR(error.message);
                }
                this.WAITING(false)
            },
            async getUserInfo(uIds)
            {
                try
                {
                    this.HIDE_SNACKBAR();
                    await this.GET_USERS({uIds: uIds});
                    this.usersSelected = this.users
                }
                catch (error)
                {
                    this.SHOW_SNACKBAR_ERROR(error.message);
                }
                this.WAITING(false)
            },
            listGeneration(items)
            {
                let itemNamesOnly = [];
                for (const [, value] of Object.entries(items))
                {
                    if (value !== 'N/A')
                    {
                        itemNamesOnly.push(value)
                    }
                }
                return itemNamesOnly
            },
            keyFromList(item, items)
            {
                for (const [key, value] of Object.entries(items))
                {
                    if (item === value)
                    {
                        return key
                    }
                }
                return null
            },
            keysFromList(itemz, items)
            {
                let keys = [];
                for (const item of itemz)
                {
                    for (const [key, value] of Object.entries(items))
                    {
                        if (item === value)
                        {
                            keys.push(key);
                            break
                        }
                    }
                }
                return keys.length > 0 ? keys : null
            },
            valuesFromList(itemz, items)
            {
                let values = [];
                for (const item of itemz)
                {
                    for (const [key, value] of Object.entries(items))
                    {
                        if (item === key)
                        {
                            values.push(value);
                            break
                        }
                    }
                }
                return values.length > 0 ? values : null
            },
            buildDestination()
            {
                let destination = {};
                const jobCodes = this.keysFromList(this.jobsSelected, jobs);
                if (jobCodes)
                {
                    destination['1'] = jobCodes
                }
                const useCodes = this.keysFromList(this.usesSelected, uses);
                if (useCodes)
                {
                    destination['2'] = useCodes
                }
                if (this.usersSelected.length > 0)
                {
                    const uIds = [];
                    for (const userSelected of this.usersSelected)
                    {
                        uIds.push(userSelected.uId)
                    }
                    destination['3'] = uIds
                }
                return destination
            },
            selectUser()
            {
                this.userSearchDialog = true
            },
            userSearchDialogClose(payload)
            {
                this.userSearchDialog = false
                if (payload)
                {
                    let unique = {};
                    this.usersSelected.push(payload);
                    // Remove the selected user if it was already selected
                    this.usersSelected = this.usersSelected.filter(obj => !unique[obj.id] && (unique[obj.id] = true))
                }
            }
        }
    };
</script>

<style scoped>
</style>